const lazyLoadVideos = () =>{
  let lazyVideos = [...document.querySelectorAll('video.js-video-loader')]
  if(lazyVideos.length < 1) return


  let isMobile = window.matchMedia(`(max-width:767px)`).matches,
      isTablet = window.matchMedia(`(min-width:768px) and (max-width:991px)`).matches,
      isDesktop = window.matchMedia(`(min-width: 992px)`).matches;

  function checkResponsive(video) {
    let showOn = video.parentElement.dataset.responsiveShow
    if(!showOn) return setSource(video);
    
    switch (showOn) {
      case "desktop":
        if(isDesktop){
          setSource(video)
        }
        break;
  
      case "tablet":
        if(isTablet){
          setSource(video)
        }
        break;
  
      case "mobile":
        if(isMobile){
          setSource(video)
        }
        break;
    }
    
  }
  function checkLoadTime(video) {
      // Creiamo la prima promise, che si risolve
      // in corrispondenza dell'evento video.canplaythrough
      const videoLoad = new Promise((resolve) => {
        video.addEventListener('canplaythrough', () => {
          resolve('can play');
        });
      });

      // Creiamo la seconda promise, che si risolve
      // dopo un tempo predefinito (2 secondi)
      const videoTimeout = new Promise((resolve) => {
        setTimeout(() => {
          resolve('The video timed out.');
        }, 2000);
      });


      // Sfruttiamo il metodo race
      Promise.race([videoLoad, videoTimeout]).then((data) => {
        if (data === 'can play') {
          
          video.play()
          setTimeout(() => {
            video.classList.add('video-loaded');
          }, 500);
        }
      });
  }

  function setSource (video) {
      let children = Array.from(video.children);
      children.forEach(child => {
        if ( child.tagName === 'SOURCE' && typeof child.dataset.src !== 'undefined' ) {
            child.setAttribute('src', child.dataset.src);
            video.muted = true; // Ensure video is muted for autoplay
            video.loop = true; // Ensure video is muted for autoplay
            video.playsInline = true; // Allow inline playback on iPhones
        }
      });
  }

  function loadVideo(video) {
      checkResponsive(video)
      video.load();
      checkLoadTime(video);
  }
 
  function checkImmediateLoad() {
    lazyVideos.forEach(video => {
        const rect = video.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            loadVideo(video); // Load videos that are in the initial viewport
        }
    });
  }

  if ("IntersectionObserver" in window) {
      let lazyVideoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
              loadVideo(video.target)
              lazyVideoObserver.unobserve(video.target);
          }
        });
      });
   
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });

      // Check for videos that are already in the initial viewport
       checkImmediateLoad();
    }else{
      // IF OBSERVER NOT SUPORTED
      // Check for videos that are already in the initial viewport
      checkImmediateLoad();
    }

}

document.addEventListener("DOMContentLoaded", lazyLoadVideos);